<template>
  <div class="wordinfo-page">
    <el-tabs v-model="activeTab" type="card" class="word-tabs">
      <el-tab-pane label="单词详解" name="detail" lazy>
        <SimpleWord />
      </el-tab-pane>
      <el-tab-pane label="独立发音" name="individual" lazy>
        <IndividualPhonetic @back="backToDetail" />
      </el-tab-pane>
      <el-tab-pane label="拼音发音" name="chinese" lazy>
        <ChineseSyllable @back="backToDetail" />
      </el-tab-pane>
      <el-tab-pane label="音节发音" name="american" lazy>
        <AmericanSyllable @back="backToDetail" />
      </el-tab-pane>
      <el-tab-pane label="组合发音" name="free" lazy>
        <FreeSelectPhonetic @back="backToDetail" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SimpleWord from '../components/word/SimpleWord.vue'
import IndividualPhonetic from '../components/word/IndividualPhonetic.vue'
import ChineseSyllable from '../components/word/ChineseSyllable.vue'
import AmericanSyllable from '../components/word/AmericanSyllable.vue'
import FreeSelectPhonetic from '../components/word/FreeSelectPhonetic.vue'

export default {
  name: 'WordInfo',
  components: {
    SimpleWord,
    IndividualPhonetic,
    ChineseSyllable,
    AmericanSyllable,
    FreeSelectPhonetic
  },
  data() {
    return {
      activeTab: 'detail'
    }
  },
  watch: {
    // 切换单词时回到「单词详解」，优先展示单词信息
    '$store.state.word'() {
      this.activeTab = 'detail'
    }
  },
  methods: {
    backToDetail() {
      this.activeTab = 'detail'
    }
  }
}
</script>

<style scoped>
.wordinfo-page {
  min-height: 400px;
}
</style>
